var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["family/family-title.j2"] = require( "family/family-title.j2" );
dependencies["family/family-product-image-viewer-outer.j2"] = require( "family/family-product-image-viewer-outer.j2" );
dependencies["family/family-product-meta-layout.j2"] = require( "family/family-product-meta-layout.j2" );
dependencies["family/family-product-actions.j2"] = require( "family/family-product-actions.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-shop-the-set.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"s-family-product\">\n\n    <div class=\"dom-product-shop-the-set\">\n\n        <a name=\"shop-the-set\" class=\"c-family-product__anchor js-product-shop-the-set\"></a>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"familyProducts") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"familyProducts")) > 0) {
env.getTemplate("family/family-title.j2", false, "product/templates/product-shop-the-set.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            ";
var t_5;
t_5 = runtime.contextOrFrameLookup(context, frame, "product");
frame.set("originalProduct", t_5, true);
if(frame.topLevel) {
context.setVariable("originalProduct", t_5);
}
if(frame.topLevel) {
context.addExport("originalProduct", t_5);
}
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"familyProducts");
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("familyProduct", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
var t_10;
t_10 = t_9;
frame.set("product", t_10, true);
if(frame.topLevel) {
context.setVariable("product", t_10);
}
if(frame.topLevel) {
context.addExport("product", t_10);
}
output += "\n                ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "True");
frame.set("disableZoom", t_11, true);
if(frame.topLevel) {
context.setVariable("disableZoom", t_11);
}
if(frame.topLevel) {
context.addExport("disableZoom", t_11);
}
output += "\n                ";
var t_12;
t_12 = runtime.contextOrFrameLookup(context, frame, "True");
frame.set("forFamilyProduct", t_12, true);
if(frame.topLevel) {
context.setVariable("forFamilyProduct", t_12);
}
if(frame.topLevel) {
context.addExport("forFamilyProduct", t_12);
}
output += "\n\n                ";
var t_13;
t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product");
frame.set("innerProduct", t_13, true);
if(frame.topLevel) {
context.setVariable("innerProduct", t_13);
}
if(frame.topLevel) {
context.addExport("innerProduct", t_13);
}
output += "\n                ";
var t_14;
t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta");
frame.set("productMeta", t_14, true);
if(frame.topLevel) {
context.setVariable("productMeta", t_14);
}
if(frame.topLevel) {
context.addExport("productMeta", t_14);
}
output += "\n                ";
var t_15;
t_15 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls");
frame.set("productControls", t_15, true);
if(frame.topLevel) {
context.setVariable("productControls", t_15);
}
if(frame.topLevel) {
context.addExport("productControls", t_15);
}
output += "\n                ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"primarySlice");
frame.set("primarySlice", t_16, true);
if(frame.topLevel) {
context.setVariable("primarySlice", t_16);
}
if(frame.topLevel) {
context.addExport("primarySlice", t_16);
}
output += "\n\n                ";
output += "\n                <script type=\"application/ld+json\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "schema")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"styleNumber"))), env.opts.autoescape);
output += "\n                </script>\n\n                <div class=\"dom-family-product\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" data-qa-family-products>\n\n                    <form novalidate id=\"family-product-add-form-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" action=\"#\" method=\"post\" class=\"c-form js-product-add-form\">\n\n                        <div class=\"o-row c-family-product__inner\">\n\n                            ";
env.getTemplate("family/family-product-image-viewer-outer.j2", false, "product/templates/product-shop-the-set.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                            ";
env.getTemplate("family/family-product-meta-layout.j2", false, "product/templates/product-shop-the-set.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n                            ";
env.getTemplate("family/family-product-actions.j2", false, "product/templates/product-shop-the-set.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n                        </div>\n\n                    </form>\n\n                    <div class=\"o-row\">\n\n                        <div class=\"o-column o-extra-small--12\">\n\n                            <hr class=\"c-family-product__hr ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "c-family-product__hr--last";
;
}
output += "\" />\n\n                        </div>\n\n                    </div>\n\n                </div>";
})})})})})});
}
}
frame = frame.pop();
var t_29;
t_29 = runtime.contextOrFrameLookup(context, frame, "originalProduct");
frame.set("product", t_29, true);
if(frame.topLevel) {
context.setVariable("product", t_29);
}
if(frame.topLevel) {
context.addExport("product", t_29);
}
})});
}
output += "</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-shop-the-set.j2"] , dependencies)